export const SuggestionsQuestions1 =[
    {
        id:"R1-01",
        category:"一般閱讀題",
        type:'選擇題',
        question: '根據篇章1，柳宗元被貶永州後寫下哪一篇作品？',
        options:[
            {
                option:'A. 〈江雪〉',
            },
            {
                option:'B. 〈陋室銘〉',
            },
            {
                option:'C. 〈醉翁亭記〉',
            },
            {
                option:'D. 〈岳陽樓記〉',
            }
        ],
        correctAnswer:'A. 〈江雪〉',
        explanation: '篇章1第二段直接交代作品與貶謫地點。',
        score: 1,
        source: '篇章1 第2段',
        articleIndex: [0]
    },{
        id:"R1-02",
        category:"一般閱讀題",
        type:'選擇題',
        question: '篇章1所說「建立了一道隔絕世界的墻壁」，主要指甚麼？',
        options:[
            {
                option:'A. 實際修築圍牆以阻止訪客',
            },
            {
                option:'B. 透過文學爭取重返朝廷',
            },
            {
                option:'C. 以自守的態度保護內在品格',
            },
            {
                option:'D. 完全失去閱讀和寫作的能力',
            }
        ],
        correctAnswer:'C. 以自守的態度保護內在品格',
        explanation: '「墻壁」是比喻，指向內自守的精神狀態。',
        score: 1,
        source: '篇章1 第3段',
        articleIndex: 0,
    },{
        id:"R1-03",
        category:"一般閱讀題",
        type:'選擇題',
        question: '根據篇章2，「慶曆新政」限制哪一種特權？',
        options:[
            {
                option:'A. 地方百姓自行耕作',
            },
            {
                option:'B. 文人選擇寫作題材',
            },
            {
                option:'C. 官員上奏提出意見',
            },
            {
                option:'D. 高官子弟不經科舉直接當官',
            }
        ],
        correctAnswer:'D. 高官子弟不經科舉直接當官',
        explanation: '篇章2列出的改革重點包括限制恩蔭特權。',
        score: 1,
        source: '篇章2 慶曆新政部分',
        articleIndex: [1],
    },
    {
        id:"R1-04",
        category:"一般閱讀題",
        type:'選擇題',
        question: '根據篇章3，「不求聲譽」最能反映歐陽修哪一種施政取向？',
        options:[
            {
                option:'A. 重視宣傳而輕視實際成效',
            },
            {
                option:'B. 重視百姓生活而不刻意追求虛名',
            },
            {
                option:'C. 不願處理任何地方事務',
            },
            {
                option:'D. 希望百姓以私人恩惠回報他',
            }
        ],
        correctAnswer:'B. 重視百姓生活而不刻意追求虛名',
        explanation: '須連同「寬簡而不擾」「民便之」理解。',
        score: 1,
        source: '篇章3 第3段及語譯',
        articleIndex: [2],
    },
    {
        id:"R1-05",
        category:"一般閱讀題",
        type:'選擇題',
        question: '讀完篇章1至3，哪一項最能回應「如何理解歐陽修的樂」？',
        options:[
            {
                option:'A. 他只因離開朝廷而快樂',
            },
            {
                option:'B. 他因百姓稱讚文采而快樂',
            },
            {
                option:'C. 他在地方履行責任，並以百姓安穩為樂',
            },
            {
                option:'D. 他因不再承擔公務而快樂',
            }
        ],
        correctAnswer:'C. 他在地方履行責任，並以百姓安穩為樂',
        explanation: '篇章1的與民同樂，與篇章2、3的寬簡不擾民互相補充。',
        score: 1,
        source: '篇章1末段；篇章2滁州之治；篇章3第3段',
        articleIndex: [0,1,2],
    },
    {
        id:"R1-06",
        category:"一般閱讀題",
        type:'短答題',
        question: '根據篇章1，解釋「斯是陋室，惟吾德馨」在文中的意思。',
        correctAnswer: '住處雖簡陋，只要自己的品德高尚，便不必因外在貧困而自卑。',
        explanation: '指出住處簡陋（1分）；說明重視內在品德、多於外在條件（1分）。',
        score: 2,
        source: '篇章1 第3段',
        articleIndex: [0],
    },
    {
        id:"R1-07",
        category:"一般閱讀題",
        type:'短答題',
        question: '根據篇章2，歐陽修為甚麼寫信責備高若訥？請列出兩點。',
        correctAnswer: '高若訥身為諫官，沒有為受貶的范仲淹辯護，反而批評范仲淹、落井下石。',
        explanation: '沒有履行諫官應有的辯護責任（1分）；反而批評范仲淹（1分）。',
        score: 2,
        source: '篇章2 第一次被貶部分',
        articleIndex: [1],
    },
    {
        id:"R1-08",
        category:"一般閱讀題",
        type:'短答題',
        question: '篇章2如何解釋「慶曆新政」由推行到失敗的過程？請寫出三個相連的要點。',
        correctAnswer: '改革考核官員並限制恩蔭特權，觸動權貴既得利益，因而遭保守派強烈反對並告失敗。',
        explanation: '改革內容（1分）；觸動利益（1分）；遭反對而失敗（1分）。',
        score: 3,
        source: '篇章2 慶曆新政部分',
        articleIndex: [1],
    },
    {
        id:"R1-09",
        category:"一般閱讀題",
        type:'短答題',
        question: '篇章3中歐陽修說「吾未嘗以私恩惠及民，民亦不怨」。為甚麼沒有私人恩惠，百姓仍可不怨？',
        correctAnswer: '因為他約束官吏、採取寬簡而不擾民的施政，使百姓安定，並非靠私人施惠換取支持。',
        explanation: '指出約束官吏或寬簡不擾民（1分）；說明良好公共治理能保障百姓生活（1分）。',
        score: 2,
        source: '篇章3 第3段及語譯',
        articleIndex: [2],
    },
    {
        id:"R1-10",
        category:"一般閱讀題",
        type:'短答題',
        question: '比較篇章1的文學賞析與篇章3的施政記述：兩者各從哪一方面幫助讀者理解歐陽修？',
        correctAnswer: '篇章1從作品與精神境界，說明他超越獨善其身而與民同樂；篇章3從治官方針與百姓感受，展示這種關懷的實踐。',
        explanation: '準確說明篇章1的角度（1分）；篇章3的角度（1分）；指出思想與行動互相補充（1分）。',
        score: 3,
        source: '篇章1；篇章3',
        articleIndex: [0,2],
    },
    {
        id:"R1-11",
        category:"能力點題",
        type:'選擇題',
        question: '根據篇章3，歐陽修的字是甚麼？',
        options: [
            {
                option:'A. 子美',
            },
            {
                option:'B. 永叔',
            },
            {
                option:'C. 子瞻',
            },
            {
                option:'D. 希文',
            }
        ],
        correctAnswer:'B. 永叔',
        explanation: '原文開首為「歐陽修，字永叔」。',
        score: 1,
        source: '篇章3 第1句',
        articleIndex: [2],
        ability_point: '1.1 獲取並提取文本內信息',
    },
    {
        id:"R1-12",
        category:"能力點題",
        type:'選擇題',
        question: '根據篇章2，歐陽修到滁州出任何職？',
        options: [
            {
                option:'A. 司諫',
            },
            {
                option:'B. 宰相',
            },
            {
                option:'C. 縣令',
            },
            {
                option:'D. 知州',
            }
        ],
        correctAnswer:'D. 知州',
        explanation: '篇章2明言外放到滁州出任知州。',
        score: 1,
        source: '篇章2 慶曆新政部分末句',
        articleIndex: [1],
        ability_point: '1.1 獲取並提取文本內信息',
    },
    {
        id:"R1-13",
        category:"能力點題",
        type:'短答題',
        question: '從篇章3摘錄最直接表明歐陽修分別如何對待官吏與百姓的兩句話。',
        correctAnswer: '「以嚴治官，以寬治民。」',
        explanation: '「以嚴治官」（1分）；「以寬治民」（1分）。',
        score: 2,
        source: '篇章3 第3段',
        articleIndex: [2],
        ability_point: '1.1 獲取並提取文本內信息',
    },
    {
        id:"R1-14",
        category:"能力點題",
        type:'短答題',
        question: '根據篇章2，寫出推行「慶曆新政」的三位大臣姓名。',
        correctAnswer: '范仲淹、韓琦、富弼。',
        explanation: '每個正確姓名1分，共3分。',
        score: 3,
        source: '篇章2 慶曆新政部分',
        articleIndex: [1],
        ability_point: '1.1 獲取並提取文本內信息',
    },
    {
        id:"R1-15",
        category:"能力點題",
        type:'選擇題',
        question: '你要找出〈江雪〉、〈陋室銘〉與〈醉翁亭記〉在精神面貌上的比較，應優先閱讀哪一項？',
        options: [
            {
                option:'A. 篇章1對三篇作品的分析',
            },
            {
                option:'B. 篇章2列出的中央官職',
            },
            {
                option:'C. 篇章3開首的籍貫資料',
            },
            {
                option:'D. 篇章3記載的升遷次序',
            }
        ],
        correctAnswer:'A. 篇章1對三篇作品的分析',
        explanation: '篇章1以三篇作品的精神面貌為主題，最切合搜尋目的。',
        score: 1,
        source: '篇章1至3 標題及內容',
        articleIndex: [0,1,2],
        ability_point: '1.2 跨來源搜索、導航與篩選',
    },
    {
        id:"R1-16",
        category:"能力點題",
        type:'選擇題',
        question: '你要同時尋找歐陽修施政方針的文言表述及白話解釋，哪一條閱讀路徑最合適？',
        options: [
            {
                option:'A. 只讀篇章1中的〈江雪〉',
            },
            {
                option:'B. 只讀篇章2的改革背景',
            },
            {
                option:'C. 先讀篇章3末段，再對照該段語譯',
            },
            {
                option:'D. 先找篇章3的籍貫，再讀〈陋室銘〉',
            }
        ],
        correctAnswer:'C. 先讀篇章3末段，再對照該段語譯',
        explanation: '篇章3末段與語譯直接提供同一施政方針的兩種表述。',
        score: 1,
        source: '篇章3 原文及語譯',
        articleIndex: [2],
        ability_point: '1.2 跨來源搜索、導航與篩選',
    },
    {
        id:"R1-17",
        category:"能力點題",
        type:'短答題',
        question: '你要研究「改革如何觸動權貴利益，並影響歐陽修的處境」。應優先選讀哪個篇章的哪一部分？請說明理由。',
        options: [],
        correctAnswer:'優先讀篇章2「觸動既得利益的慶曆新政」，該部分交代改革措施、權貴反對及歐陽修受誣被外放的過程。',
        explanation: '正確篇章及部分（1分）；說明與研究問題直接相關的資料（1分）。',
        score: 2,
        source: '篇章2 慶曆新政部分',
        articleIndex: [1],
        ability_point: '1.2 跨來源搜索、導航與篩選',
    },
    {
        id:"R1-18",
        category:"能力點題",
        type:'短答題',
        question: '若要比較「文學中的與民同樂」和「行政上的不擾民」，請從兩個不同篇章各選一處最相關的資料，並說明用途。',
        options: [],
        correctAnswer:'選篇章1末段，了解與民同樂的精神；選篇章3第3段「以嚴治官，以寬治民」，了解行政實踐。亦可選篇章2「滁州之治」。',
        explanation: '兩個不同篇章的合適位置各1分；清楚說明兩項資料的用途各1分。',
        score: 4,
        source: '篇章1末段；篇章2滁州之治或篇章3第3段',
        articleIndex: [0,1,2],
        ability_point: '1.2 跨來源搜索、導航與篩選',
    },
    {
        id:"R1-19",
        category:"能力點題",
        type:'選擇題',
        question: '篇章3「寬簡而不擾」在文中是甚麼意思？',
        options: [
            {
                option:'A. 放任官員，避免查核政務',
            },
            {
                option:'B. 以寬大簡約的方式施政，不侵擾百姓',
            },
            {
                option:'C. 只處理容易的公務，其餘擱置',
            },
            {
                option:'D. 以私人禮物換取百姓稱讚',
            }
        ],
        correctAnswer:'B. 以寬大簡約的方式施政，不侵擾百姓',
        explanation: '語譯把這句解釋為寬大執政、簡約不擾民。',
        score: 1,
        source: '篇章3 第3段及語譯',
        articleIndex: [2],
        ability_point: '2.1 建構文本字面意義',
    },
    {
        id:"R1-20",
        category:"能力點題",
        type:'選擇題',
        question: '篇章2「以天下為己任」的意思最接近哪一項？',
        options: [
            {
                option:'A. 把天下的財物視為個人所有',
            },
            {
                option:'B. 只在獲皇帝賞識時才履職',
            },
            {
                option:'C. 把維護國家與百姓的福祉看作自己的責任',
            },
            {
                option:'D. 以個人名聲作為所有決定的準則',
            }
        ],
        correctAnswer:'C. 把維護國家與百姓的福祉看作自己的責任',
        explanation: '文中將此使命感連繫到說真話、維護道義。',
        score: 1,
        source: '篇章2 政治地位部分',
        articleIndex: [1],
        ability_point: '2.1 建構文本字面意義',
    },
    {
        id:"R1-21",
        category:"能力點題",
        type:'短答題',
        question: '用白話解釋篇章3「為政寬簡，而事不廢」。',
        correctAnswer: '施政寬大簡約，但應辦的公務並沒有被耽誤或荒廢。',
        explanation: '寬大簡約（1分）；公務未荒廢（1分）。',
        score: 2,
        source: '篇章3 第3段及語譯',
        articleIndex: [2],
        ability_point: '2.1 建構文本字面意義',
    },
    {
        id:"R1-22",
        category:"能力點題",
        type:'短答題',
        question: '篇章1把柳宗元和劉禹錫的態度概括為「獨善其身」。這個詞在文中指甚麼？',
        correctAnswer: '在逆境中守護自己的品德與內心，以保持清高或純潔的精神世界。',
        explanation: '守護個人品德（1分）；維持內心或精神世界（1分）。',
        score: 2,
        source: '篇章1 第3至4段',
        articleIndex: [0],
        ability_point: '2.1 建構文本字面意義',
    },
    {
        id:"R1-23",
        category:"能力點題",
        type:'選擇題',
        question: '根據〈從「孤傲自守」到「與民同樂」〉一文，作者在比較〈江雪〉、〈陋室銘〉和〈醉翁亭記〉後，最欣賞下列哪一種境界？',
        options: [
            {
                option:'A. 遠離世事，孤傲自守',
            },
            {
                option:'B. 安於個人生活，自得其樂',
            },
            {
                option:'C. 關懷他人，與民同樂',
            },
            {
                option:'D. 三種境界並無高下之分',
            }
        ],
        correctAnswer:'C. 關懷他人，與民同樂',
        explanation: '作者以「最高境界」評價把個人榮辱轉化為對蒼生之愛。',
        score: 1,
        source: '單元習題 閱讀1／2.2 選擇題1；篇章1',
        articleIndex: [0],
        ability_point: '2.2 生成推斷',
        isSuggested: true
    },
    {
        id:"R1-24",
        category:"能力點題",
        type:'選擇題',
        question: '篇章2說歐陽修明知責備高若訥可能招致流放，仍表示「亦所不恨」。可推斷他把哪一項放在較高位置？',
        options: [
            {
                option:'A. 個人的升遷速度',
            },
            {
                option:'B. 同僚之間的表面和諧',
            },
            {
                option:'C. 避免一切政治風險',
            },
            {
                option:'D. 維護道義與履行諫官責任',
            }
        ],
        correctAnswer:'D. 維護道義與履行諫官責任',
        explanation: '他願承擔受罰風險，反映道義重於個人安危。',
        score: 1,
        source: '篇章2 第一次被貶部分',
        articleIndex: [1],
        ability_point: '2.2 生成推斷',
    },
    {
        id:"R1-25",
        category:"能力點題",
        type:'短答題',
        question: '在〈從「孤傲自守」到「與民同樂」〉一文中，作者分別提及〈江雪〉、〈陋室銘〉和〈醉翁亭記〉，你認為三者中哪一種是作者最欣賞的境界？為甚麼？',
        options: [],
        correctAnswer:'最欣賞〈醉翁亭記〉的「與民同樂」。作者認為歐陽修從個人自守走向關懷百姓，把個人榮辱化為蒼生之愛，並稱為「最高境界」。',
        explanation: '指出與民同樂（1分）；說明由個人轉向百姓（1分）；引用或概述作者的評價作證（1分）。',
        score: 3,
        source: '單元習題 閱讀1／2.2 原短答題；篇章1',
        articleIndex: [0],
        ability_point: '2.2 生成推斷',
        isSuggested: true
    },
    {
        id:"R1-26",
        category:"能力點題",
        type:'短答題',
        question: '根據篇章3「不求聲譽」與「故所至民便之」，你可推斷歐陽修如何衡量施政是否成功？',
        options: [],
        correctAnswer:'他較重視百姓是否生活便利安定，而不是自己是否獲得顯赫聲譽。',
        explanation: '合理推斷成功標準（1分）；以兩處文字的關係支持推斷（1分）。',
        score: 2,
        source: '篇章3 第3段',
        articleIndex: [2],
        ability_point: '2.2 生成推斷',
    },
    {
        id:"R1-27",
        category:"能力點題",
        type:'選擇題',
        question: '根據〈歐陽修被貶滁州的相關歷史事件〉一文，下列哪一項最能概括歐陽修在中央和地方為官時的共同表現？',
        options: [
            {
                option:'A. 遇到政治挫折後不再過問政事',
            },
            {
                option:'B. 無論身處中央或地方，都盡力履行為官責任',
            },
            {
                option:'C. 在中央重視政事，在地方只寄情山水',
            },
            {
                option:'D. 主要以文學創作作為自己的責任',
            }
        ],
        correctAnswer:'B. 無論身處中央或地方，都盡力履行為官責任',
        explanation: '文中中央支持改革、地方寬簡不擾民，皆體現履責。',
        score: 1,
        source: '單元習題 閱讀1／2.3 選擇題1；篇章2',
        articleIndex: [1],
        ability_point: '2.3 整合文本內信息',
        isSuggested: true
    },
    {
        id:"R1-28",
        category:"能力點題",
        type:'選擇題',
        question: '綜合篇章1對三位文人的分析，哪一項最完整地概括文章的論述次序？',
        options: [
            {
                option:'A. 孤傲自守、保持德馨，再轉向與民同樂',
            },
            {
                option:'B. 政治成功、失去品格，再轉向追求財富',
            },
            {
                option:'C. 共享歡樂、厭棄百姓，再轉向獨居',
            },
            {
                option:'D. 放棄寫作、支持改革，再轉向爭奪權位',
            }
        ],
        correctAnswer:'A. 孤傲自守、保持德馨，再轉向與民同樂',
        explanation: '文章依次分析柳宗元、劉禹錫、歐陽修的精神面貌。',
        score: 1,
        source: '篇章1 全文',
        articleIndex: [0],
        ability_point: '2.3 整合文本內信息',
    },
    {
        id:"R1-29",
        category:"能力點題",
        type:'短答題',
        question: '根據〈歐陽修被貶滁州的相關歷史事件〉一文，歐陽修在中央和地方當官時，如何盡力履行為官的責任？試綜合全文，舉出兩個例子並略加說明。',
        options: [],
        correctAnswer:'在中央，他支持慶曆新政，以整頓吏治改善國政；在地方，他嚴格約束官吏，對百姓寬簡不擾，保障生活安定。中央例子亦可用責備高若訥、維護道義。',
        explanation: '中央事例及履責說明各1分；地方事例及履責說明各1分。',
        score: 4,
        source: '單元習題 閱讀1／2.3 原短答題；篇章2',
        articleIndex: [1],
        ability_point: '2.3 整合文本內信息',
        isSuggested: true
    },
    {
        id:"R1-30",
        category:"能力點題",
        type:'短答題',
        question: '綜合篇章3第3段，說明「嚴治官」「寬治民」與「此所以樂也」三者的關係。',
        options: [],
        correctAnswer:'嚴格約束官吏可使公務不廢；寬簡對待百姓可減少侵擾，使百姓安定、不怨。這種治理成效正是歐陽修的快樂來源。',
        explanation: '嚴治官的作用（1分）；寬治民的作用（1分）；將兩者連繫到其樂（1分）。',
        score: 3,
        source: '篇章3 第3段',
        articleIndex: [2],
        ability_point: '2.3 整合文本內信息',
    },
    {
        id:"R1-31",
        category:"能力點題",
        type:'選擇題',
        question: '綜合互文閱讀1「作者處境」篇章1至3，下列哪一項最適合概括歐陽修的「襟懷」？',
        options: [
            {
                option:'A. 面對逆境時只求保全自己',
            },
            {
                option:'B. 即使身處逆境，仍能關懷百姓並承擔責任',
            },
            {
                option:'C. 把政治失意完全轉化為個人的山水享樂',
            },
            {
                option:'D. 認為文人應遠離政治與社會',
            }
        ],
        correctAnswer:'B. 即使身處逆境，仍能關懷百姓並承擔責任',
        explanation: '三篇分別從精神境界、政治處境與施政表現支持此概括。',
        score: 1,
        source: '單元習題 閱讀1／2.4 選擇題1；篇章1至3',
        articleIndex: [0,1,2],
        ability_point: '2.4 整合跨文本信息',
        isSuggested: true
    },
    {
        id:"R1-32",
        category:"能力點題",
        type:'選擇題',
        question: '把篇章1的「與民同樂」與篇章3的「民不擾則安」合讀，最合理的理解是甚麼？',
        options: [
            {
                option:'A. 文學中的樂與百姓生活毫無關係',
            },
            {
                option:'B. 只要辦宴席便無須處理政務',
            },
            {
                option:'C. 與民同樂包含使百姓生活安定的施政基礎',
            },
            {
                option:'D. 寬簡施政只是為了騰出更多遊樂時間',
            }
        ],
        correctAnswer:'C. 與民同樂包含使百姓生活安定的施政基礎',
        explanation: '合讀可將文學表現與公共治理連繫起來。',
        score: 1,
        source: '篇章1末段；篇章3第3段',
        articleIndex: [0,2],
        ability_point: '2.4 整合跨文本信息',
    },
    {
        id:"R1-33",
        category:"能力點題",
        type:'短答題',
        question: '根據互文閱讀1：「作者處境」篇章1-3，你會怎麼樣形容歐陽修的「襟懷」？試從上述最少兩個篇章中各舉一例說明。',
        correctAnswer: '可形容為豁達而心繫百姓。篇章1說他走出個人自守、與民同樂；篇章2說他在改革失敗後仍在滁州實踐護民信念。亦可引用篇章3的寬簡不擾。',
        explanation: '恰當概括（1分）；兩個不同篇章的事例各1分；說明事例與襟懷的關係（1分）。',
        score: 4,
        source: '單元習題 閱讀1／2.4 原短答題；篇章1至3',
        articleIndex: [0,1,2],
        ability_point: '2.4 整合跨文本信息',
        isSuggested: true
    },
    {
        id:"R1-34",
        category:"能力點題",
        type:'短答題',
        question: '篇章2交代歐陽修支持慶曆新政，篇章3記述他「以嚴治官」。兩者如何體現同一種為官理念？請分別引用或概述證據。',
        correctAnswer: '中央改革考核官員、淘汰不稱職者；地方嚴格約束官吏、不讓公務荒廢。兩者都重視官員履責，以改善治理、保障百姓。',
        explanation: '篇章2證據（1分）；篇章3證據（1分）；概括共同理念（1分）。',
        score: 3,
        source: '篇章2 慶曆新政；篇章3第3段',
        articleIndex: [1,2],
        ability_point: '2.4 整合跨文本信息',
    },
    {
        id:"R1-35",
        category:"能力點題",
        type:'選擇題',
        question: '若要確認篇章3是否逐字引自《宋史》，哪種做法最可靠？',
        options: [
            {
                option:'A. 因標題有《宋史》便直接接受',
            },
            {
                option:'B. 以文章語氣是否古雅判斷',
            },
            {
                option:'C. 只比較同一教材的白話語譯',
            },
            {
                option:'D. 查對有版本及卷次資料的《宋史》原文',
            }
        ],
        correctAnswer:'D. 查對有版本及卷次資料的《宋史》原文',
        explanation: '標題與語譯不足以核實逐字引文；須核對可追溯版本。',
        score: 1,
        source: '篇章3 標題、原文及語譯',
        articleIndex: [2],
        ability_point: '3.1 評估質量與真實性',
    },
    {
        id:"R1-36",
        category:"能力點題",
        type:'選擇題',
        question: '篇章2與篇章3都寫到同一段施政方針。這能否直接算作兩份互相獨立的史料證據？',
        options: [
            {
                option:'A. 不能，仍須查明兩篇是否引用同一來源',
            },
            {
                option:'B. 能，因為分成兩個篇章',
            },
            {
                option:'C. 能，因為一篇文言、一篇白話',
            },
            {
                option:'D. 不能，因為白話資料一律無效',
            }
        ],
        correctAnswer:'A. 不能，仍須查明兩篇是否引用同一來源',
        explanation: '文字一致可能出於共同來源，不能只按篇數計算獨立證據。',
        score: 1,
        source: '篇章2 滁州之治；篇章3第3段',
        articleIndex: [1,2],
        ability_point: '3.1 評估質量與真實性',
    },
    {
        id:"R1-37",
        category:"能力點題",
        type:'短答題',
        question: '有同學說：「篇章1稱與民同樂為最高境界，所以歷來所有讀者必定都最欣賞歐陽修。」請評估這個說法的證據是否足夠。',
        options: [],
        correctAnswer:'不足。篇章1只表達該作者的文學評價，沒有提供歷來所有讀者的意見，不能由一人的評價推論所有人的看法。',
        explanation: '辨明作者評價（1分）；指出概括範圍超出證據（1分）；得出有理由的判斷（1分）。',
        score: 3,
        source: '篇章1 末段',
        articleIndex: [0],
        ability_point: '3.1 評估質量與真實性',
    },
    {
        id:"R1-38",
        category:"能力點題",
        type:'短答題',
        question: '若要把篇章2「減輕賦稅、簡化法令」寫入歷史報告，應如何核實？請提出兩項具體查證工作。',
        options: [],
        correctAnswer:'查找這項說法所據的史料及卷頁；再對照可靠版本或具出處的研究，確認是否專指歐陽修治滁州及具體措施。',
        explanation: '查找可追溯出處（1分）；核對時地、人物與措施是否相符（1分）。不能只答「上網搜尋」。',
        score: 2,
        source: '篇章2 滁州之治',
        articleIndex: [1],
        ability_point: '3.1 評估質量與真實性',
    },
    {
        id:"R1-39",
        category:"能力點題",
        type:'選擇題',
        question: '篇章1先寫柳宗元、劉禹錫，再寫歐陽修，主要有甚麼表達作用？',
        options: [
            {
                option:'A. 以官職高低排列人物',
            },
            {
                option:'B. 用對比突出由個人自守到關懷百姓的轉變',
            },
            {
                option:'C. 證明前兩位文人完全沒有品德',
            },
            {
                option:'D. 交代三人在同一宴席的言行',
            }
        ],
        correctAnswer:'B. 用對比突出由個人自守到關懷百姓的轉變',
        explanation: '比較構成文章論述，凸顯作者欣賞的精神境界。',
        score: 1,
        source: '篇章1 結構',
        articleIndex: [0],
        ability_point: '3.2 反思內容與形式',
    },
    {
        id:"R1-40",
        category:"能力點題",
        type:'選擇題',
        question: '篇章2開首先提出「只是一個喜歡喝酒、遊山玩水的文人」這種印象，主要作用是甚麼？',
        options: [
            {
                option:'A. 宣告全文只談飲食娛樂',
            },
            {
                option:'B. 要求讀者忽略歷史背景',
            },
            {
                option:'C. 把猜測當作已證實的事實',
            },
            {
                option:'D. 提出待修正的印象，引出理解政治背景的必要',
            }
        ],
        correctAnswer:'D. 提出待修正的印象，引出理解政治背景的必要',
        explanation: '開首先提出常見印象，再藉歷史背景深化對其樂的理解。',
        score: 1,
        source: '篇章2 第1段',
        articleIndex: [1],
        ability_point: '3.2 反思內容與形式',
    },
    {
        id:"R1-41",
        category:"能力點題",
        type:'短答題',
        question: '篇章1用「墻壁」比喻柳宗元和劉禹錫的自守。這個比喻如何幫助讀者理解他們與外界的關係？',
        options: [],
        correctAnswer:'牆壁有隔離和保護的作用，使抽象的精神自守變得具體，突顯他們保護品格而與外界保持距離。',
        explanation: '說明比喻的隔離／保護特點（1分）；連繫到精神自守（1分）；說明具體化的效果（1分）。',
        score: 3,
        source: '篇章1 第3段',
        articleIndex: [0],
        ability_point: '3.2 反思內容與形式',
    },
    {
        id:"R1-42",
        category:"能力點題",
        type:'短答題',
        question: '篇章3採用「或問」與歐陽修回答的形式，對說明其施政理念有何作用？',
        options: [],
        correctAnswer:'提問點出寬簡施政卻公務不廢的疑問；回答直接交代嚴治官、寬治民的理由，讓理念與成效的關係更清楚。',
        explanation: '指出問題所聚焦的疑問（1分）；說明答話如何解釋理念或增強直接感（1分）。',
        score: 2,
        source: '篇章3 第3段',
        articleIndex: [2],
        ability_point: '3.2 反思內容與形式',
    },
    {
        id:"R1-43",
        category:"能力點題",
        type:'選擇題',
        question: '篇章2寫范仲淹被貶時「朝中大臣多數只顧自保而保持沉默」，篇章3則寫「在廷多論救」。面對這項差異，應怎樣處理？',
        options: [
            {
                option:'A. 選較容易理解的一篇作定論',
            },
            {
                option:'B. 把兩句都改成沒有人營救',
            },
            {
                option:'C. 指出記述不一致，再查對原始史料及語境',
            },
            {
                option:'D. 因歐陽修有寫信，便認為兩句完全相同',
            }
        ],
        correctAnswer:'C. 指出記述不一致，再查對原始史料及語境',
        explanation: '兩篇對多數朝臣反應的描述有明顯差異，須保留問題並查證。',
        score: 1,
        source: '篇章2 第一次被貶；篇章3第1段',
        articleIndex: [1,2],
        ability_point: '3.3 發現並處理衝突',
    },
    {
        id:"R1-44",
        category:"能力點題",
        type:'選擇題',
        question: '同學認為篇章3的「為政寬簡」與「以嚴治官」互相矛盾。哪一項回應最合理？',
        options: [
            {
                option:'A. 兩者對象不同，對官吏嚴格與對百姓寬簡可以並行',
            },
            {
                option:'B. 「嚴」和「寬」字義相反，所以必有一句錯誤',
            },
            {
                option:'C. 歐陽修只在沒有公務時寬簡',
            },
            {
                option:'D. 文言文不需要講求前後一致',
            }
        ],
        correctAnswer:'A. 兩者對象不同，對官吏嚴格與對百姓寬簡可以並行',
        explanation: '區分施政對象，可解釋表面上的衝突。',
        score: 1,
        source: '篇章3 第3段',
        articleIndex: [2],
        ability_point: '3.3 發現並處理衝突',
    },
    {
        id:"R1-45",
        category:"能力點題",
        type:'短答題',
        question: '比較篇章2「朝中大臣多數只顧自保而保持沉默」與篇章3「在廷多論救」。指出差異，並說明查證前在報告中應怎樣表述。',
        options: [],
        correctAnswer:'前者說多數沉默，後者說朝中多人營救，對群臣反應的記述不同。報告應並列兩種記述、註明來源與待核實之處，不逕自斷定多數大臣的態度。',
        explanation: '指出前者意思（1分）；後者意思（1分）；提出保留分歧、避免武斷的寫法（1分）。',
        score: 3,
        source: '篇章2 第一次被貶；篇章3第1段',
        articleIndex: [1,2],
        ability_point: '3.3 發現並處理衝突',
    },
    {
        id:"R1-46",
        category:"能力點題",
        type:'短答題',
        question: '有人以篇章1的山水宴遊，判斷歐陽修「完全逃避責任」。請用另一篇章的資料回應，並說明兩種表現是否必然衝突。',
        options: [],
        correctAnswer:'篇章3記載他以嚴治官、以寬治民，公務未廢。宴遊與履責不必衝突，與民同樂可建立在安定治理之上。',
        explanation: '另一篇章的有效證據（1分）；指出不必然衝突（1分）；解釋二者可並存的關係（1分）。',
        score: 3,
        source: '篇章1；篇章2或3',
        articleIndex: [1,2],
        ability_point: '3.3 發現並處理衝突',
    },
    {
        id:"R1-47",
        category:"能力點題",
        type:'選擇題',
        question: '班長競選落敗後，哪一種做法最能把歐陽修在逆境中仍履責的精神應用到校園？',
        options: [
            {
                option:'A. 退出所有服務，以免再受挫',
            },
            {
                option:'B. 雖未當選，仍協助同學改善班務',
            },
            {
                option:'C. 只協助曾投票支持自己的人',
            },
            {
                option:'D. 把全部精力用來證明當選者無能',
            }
        ],
        correctAnswer:'B. 雖未當選，仍協助同學改善班務',
        explanation: '處境改變後仍服務群體，對應在地方繼續護民的精神。',
        score: 1,
        source: '篇章2、3；新增校園情境',
        articleIndex: [1,2],
        ability_point: '4.1 將理解遷移至新情境',
    },
    {
        id:"R1-48",
        category:"能力點題",
        type:'選擇題',
        question: '學生會籌辦活動，若借鑑「以嚴治官，以寬治民」，哪項安排最恰當？',
        options: [
            {
                option:'A. 嚴格限制參加者，工作人員則不用守時',
            },
            {
                option:'B. 只送禮物，不公布活動規則',
            },
            {
                option:'C. 所有規則都取消，以免增加負擔',
            },
            {
                option:'D. 訂明工作人員責任，並簡化同學報名手續',
            }
        ],
        correctAnswer:'D. 訂明工作人員責任，並簡化同學報名手續',
        explanation: '在現代情境中分別對應管理者履責與使用者便利。',
        score: 1,
        source: '篇章3 第3段；新增活動情境',
        articleIndex: [2],
        ability_point: '4.1 將理解遷移至新情境',
    },
    {
        id:"R1-49",
        category:"能力點題",
        type:'短答題',
        question: '你負責的校園服務計劃未獲採納。參照歐陽修到滁州後的表現，提出一項仍可實踐的行動，並說明它與文本的關係。',
        options: [],
        correctAnswer: '可先在班內推行小規模課後互助，回應同學需要。歐陽修未能在中央實現改革，仍在自己管轄的地方護民，啟示人在有限範圍內也可履責。',
        explanation: '可行行動（1分）；準確文本依據（1分）；說明兩種處境的連繫（1分）。',
        score: 3,
        source: '篇章2 滁州之治；新增校園情境',
        articleIndex: [1],
        ability_point: '4.1 將理解遷移至新情境',
    },
    {
        id:"R1-50",
        category:"能力點題",
        type:'短答題',
        question: '社區中心的登記程序令長者感到不便。請借鑑篇章3的治理理念，提出兩項改善方法，分別針對工作人員和服務使用者。',
        options: [],
        correctAnswer: '對工作人員訂明協助長者填表及跟進個案的責任；對使用者簡化重複登記、提供清楚指引。這分別對應嚴格要求執行者與減少百姓負擔。',
        explanation: '工作人員措施及理念連繫各1分；使用者措施及理念連繫各1分。',
        score: 4,
        source: '篇章3 第3段；新增社區情境',
        articleIndex: [2],
        ability_point: '4.1 將理解遷移至新情境',
    },
    {
        id:"R1-51",
        category:"能力點題",
        type:'選擇題',
        question: '你要為介紹歐陽修襟懷的展板擬標題，哪一項最能綜合材料並傳達新意？',
        options: [
            {
                option:'A. 以詩酒換取升官之路',
            },
            {
                option:'B. 沒有政務的山水歲月',
            },
            {
                option:'C. 身在逆境，心向百姓',
            },
            {
                option:'D. 拒絕世界，守住孤舟',
            }
        ],
        correctAnswer:'C. 身在逆境，心向百姓',
        explanation: '標題同時保留逆境與公共關懷，適合轉化成展板主旨。',
        score: 1,
        source: '篇章1至3；新增展板任務',
        articleIndex: [0,1,2],
        ability_point: '4.2 創造並傳達新意義',
    },
    {
        id:"R1-52",
        category:"能力點題",
        type:'選擇題',
        question: '要把三篇材料改寫成一段公益短片，哪一個結尾最切合文本，又能向今天的觀眾傳達意義？',
        options: [
            {
                option:'A. 即使位置改變，仍可在身邊守護他人的安穩',
            },
            {
                option:'B. 只要有好風景，所有公共問題便會消失',
            },
            {
                option:'C. 真正的成功是讓所有人知道自己的名聲',
            },
            {
                option:'D. 受挫之後，最好的選擇是永遠不再參與',
            }
        ],
        correctAnswer:'A. 即使位置改變，仍可在身邊守護他人的安穩',
        explanation: '將地方護民的主題轉化為當代訊息，沒有扭曲原文。',
        score: 1,
        source: '篇章1至3；新增短片任務',
        articleIndex: [0,1,2],
        ability_point: '4.2 創造並傳達新意義',
    },
    {
        id:"R1-53",
        category:"能力點題",
        type:'短答題',
        question: '請為「逆境中的公共責任」校園展覽寫一段40至60字的導賞文字，結合至少兩篇材料，讓未讀過文章的同學明白歐陽修的襟懷。',
        options: [],
        correctAnswer: '歐陽修被貶後，仍以寬簡施政守護百姓。他在山水間與民同樂，讓我們看到：處境雖可受限，關懷他人的心卻不必退縮。',
        explanation: '兩篇材料的準確內容（2分）；整合成清楚主旨（1分）；表達適合導賞且大致符合字數（1分）。答案不必與示例相同。',
        score: 4,
        source: '篇章1至3；新增創作任務',
        articleIndex: [0,1,2],
        ability_point: '4.2 創造並傳達新意義',
    },
    {
        id:"R1-54",
        category:"能力點題",
        type:'短答題',
        question: '以「歐陽修給受挫同學的一句話」為題，創作一句不多於25字的寄語，再用一至兩句說明它如何連繫篇章2或3。不要把創作當作歷史原話。',
        options: [],
        correctAnswer: '寄語示例：「位置雖變，仍可把身邊人的安穩放在心上。」說明：歐陽修在中央受挫後，仍在滁州以寬簡不擾的方式護民。',
        explanation: '寄語有新表達、切合受眾（1分）；準確文本依據（1分）；解釋寄語與文本的連繫（1分）。',
        score: 3,
        source: '篇章2或3；新增創作任務',
        articleIndex: [1,2],
        ability_point: '4.2 創造並傳達新意義',
    }
]